<template>
  <div class="uk-margin-top uk-margin-bottom">
    <a href="https://ucari.com/">
      <img src="/images/logo.png" alt="UCARI Logo" width="100">
    </a>
  </div>
</template>
